/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Run_NowInputs */



/**
* | output |
* | --- |
* | "Run now" |
*
* @param {Admin_Run_NowInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_run_now = /** @type {((inputs?: Admin_Run_NowInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Run_NowInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exécuter maintenant")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ejecutar ahora")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Executar agora")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esegui ora")
	return /** @type {LocalizedString} */ ("Run now")
});